import script from "./TripActivityFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./TripActivityFeed.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__